import React from 'react';

const TeamWorkload = ({ workload, loading }) => {
    if (loading) {
        return (
            <div className="bg-gray-800 rounded-lg border border-gray-700 shadow-lg overflow-hidden h-48 animate-pulse">
                <div className="bg-gray-900/50 p-4 border-b border-gray-700 h-10"></div>
            </div>
        );
    }

    const maxWorkload = workload.length > 0 ? workload[0].count : 1;

    return (
        <div className="bg-gray-800 rounded-lg border border-gray-700 shadow-lg overflow-hidden flex flex-col h-full">
            <div className="bg-gray-900/50 p-4 border-b border-gray-700 flex-shrink-0">
                <h2 className="text-purple-400 font-bold uppercase tracking-wider flex items-center gap-2 text-sm sm:text-base">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>
                    Team Workload
                </h2>
            </div>
            <div className="p-4 flex-1 overflow-y-auto">
                {workload.length > 0 ? (
                    <div className="space-y-4">
                        {workload.map((user, idx) => (
                            <div key={user.name} className="relative">
                                <div className="flex justify-between text-xs mb-1">
                                    <span className="text-gray-300 font-medium">{user.name}</span>
                                    <span className="text-gray-400">{user.count} tasks</span>
                                </div>
                                <div className="h-2 bg-gray-700 rounded-full overflow-hidden">
                                    <div
                                        className={`h-full rounded-full ${idx === 0 ? 'bg-purple-500' : 'bg-blue-500'}`}
                                        style={{ width: `${(user.count / maxWorkload) * 100}%` }}
                                    ></div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center text-gray-500 py-4">
                        No active tasks assigned.
                    </div>
                )}
            </div>
        </div>
    );
};

export default TeamWorkload;
